/*
 * tp-embed.js — Einbettungen erst nach Klick oder Einwilligung laden (IT#17146).
 *
 * Liquid (snippets/tp-embed-gate.liquid, sections/tp-store-visit.liquid) legt jeden iFrame in
 * <span class="tp-embed"><template>…</template></span> und nimmt dem Instagram-Script das src.
 * Hier: Platzhalter mit Knopf + Hinweis bauen; Klick lädt alle Einbettungen desselben Anbieters.
 * Mit Einwilligung (Shopify Customer Privacy API) laden sie ohne Klick. Nichts wird gespeichert.
 * Darf pro Seite mehrfach eingebunden sein (Guard unten).
 */
(function () {
  'use strict';
  if (window.tpEmbed) { return; }
  window.tpEmbed = true;

  var items = [];
  var done = {};

  function provider(el) {
    if (el.tagName === 'BLOCKQUOTE') {
      return { id: 'instagram', cat: 'marketing', label: 'Beitrag laden (Instagram)', who: 'Meta' };
    }
    var f = el.querySelector('template').content.querySelector('iframe');
    var src = (f && f.getAttribute('src')) || '';
    var url;
    try { url = new URL(src, location.href); } catch (e) { url = { hostname: '', pathname: '' }; }
    var host = url.hostname.replace(/^www\./, '');
    if (/(^|\.)(youtube(-nocookie)?\.com|youtu\.be)$/.test(host)) {
      return { id: 'youtube', cat: 'marketing', label: 'Video laden (YouTube)', who: 'Google' };
    }
    if (/(^|\.)google\.[a-z.]+$/.test(host) && /^\/maps/.test(url.pathname)) {
      return { id: 'maps', cat: 'preferences', label: 'Karte laden (Google)', who: 'Google' };
    }
    return { id: host, cat: 'marketing', label: 'Inhalt laden (' + host + ')', who: host };
  }

  function setup(el) {
    var p = provider(el);
    var ph = el.querySelector('.tp-embed__ph');
    if (!ph) {
      ph = document.createElement('span');
      ph.className = 'tp-embed__ph';
      if (p.id === 'instagram') { el.after(ph); } else { el.append(ph); }
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tp-embed__btn';
    btn.textContent = p.label;
    btn.addEventListener('click', function () { load(p.id, el); });
    var note = document.createElement('span');
    note.className = 'tp-embed__note';
    note.append('Beim Laden werden Daten an ' + p.who + ' übertragen. ');
    var a = document.createElement('a');
    a.href = '/policies/privacy-policy';
    a.textContent = 'Datenschutz';
    note.append(a);
    ph.append(btn, note);
    items.push({ el: el, p: p, ph: ph });
  }

  function load(id, clicked) {
    if (done[id]) { return; }
    done[id] = true;
    items.forEach(function (it) {
      if (it.p.id !== id) { return; }
      if (id === 'instagram') { it.ph.remove(); return; }
      var f = it.el.querySelector('template').content.querySelector('iframe');
      if (!f) { return; }
      if (id === 'youtube') {
        var u = new URL(f.getAttribute('src'));
        u.hostname = 'www.youtube-nocookie.com';
        if (it.el === clicked) { u.searchParams.set('autoplay', '1'); }
        f.setAttribute('src', u.href);
      }
      it.el.replaceChildren(f);
      it.el.classList.add('is-loaded');
      if (it.el === clicked) { f.focus(); }
    });
    if (id === 'instagram') {
      if (window.instgrm) { window.instgrm.Embeds.process(); return; }
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.instagram.com/embed.js';
      document.body.append(s);
    }
  }

  // d = Event-Detail (visitorConsentCollected) oder leer → aktuellen Stand aus der API lesen.
  function consent(d) {
    var ok = {};
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      ok.marketing = d ? d.marketingAllowed : cp && cp.marketingAllowed();
      ok.preferences = d ? d.preferencesAllowed : cp && cp.preferencesProcessingAllowed();
    } catch (e) { return; }
    items.forEach(function (it) { if (ok[it.p.cat] === true) { load(it.p.id, null); } });
  }

  document.querySelectorAll('.tp-embed, blockquote.instagram-media').forEach(setup);
  if (!items.length) { return; }

  document.addEventListener('visitorConsentCollected', function (e) { consent(e.detail || {}); });
  // Die Privacy-API lädt teils spät → kurz pollen, dann aufhören (wie tp-consent.js).
  var tries = 0;
  (function poll() {
    if (window.Shopify && window.Shopify.customerPrivacy) { consent(); }
    else if (tries++ < 40) { setTimeout(poll, 500); }
  })();
})();
